import { apiClient } from 'api/client/apiClient';
import { CreateApplicationApiKeyParams } from '../types';
import { API_URLS } from '../consts';

export const createApplicationApiKey = async ({ applicationId }: CreateApplicationApiKeyParams) => {
  const result = await apiClient.post(`${API_URLS.Applications}/applications/${applicationId}/api-keys`);

  return result.data;
};
